<!--<template>-->
<!--  <transition name="fade" @after-leave="showNextMessage">-->
<!--    <div v-if="isVisible" class="notification">-->
<!--      <div :class="['scrolling-text', { 'golden-glow': isGlowing }]" @animationend="handleAnimationEnd">{{ currentMessage }}</div>-->
<!--    </div>-->
<!--  </transition>-->
<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  data() {-->
<!--    return {-->
<!--      isVisible: false,-->
<!--      messageQueue: [],-->
<!--      currentMessage: '',-->
<!--      isGlowing: false,-->
<!--    };-->
<!--  },-->
<!--  mounted() {-->
<!--    // 监听 visibilitychange 事件-->
<!--    document.addEventListener('visibilitychange', this.handleVisibilityChange);-->
<!--  },-->
<!--  beforeDestroy() {-->
<!--    // 组件销毁前移除事件监听-->
<!--    document.removeEventListener('visibilitychange', this.handleVisibilityChange);-->
<!--  },-->
<!--  watch: {-->
<!--    messageQueue() {-->
<!--      // 当消息队列变化且当前没有消息显示时，显示下一条消息-->
<!--      if (!this.isVisible && this.messageQueue.length > 0) {-->
<!--        this.showNextMessage();-->
<!--      }-->
<!--    }-->
<!--  },-->
<!--  methods: {-->
<!--    handleAnimationEnd() {-->
<!--      // 动画结束，隐藏当前消息并尝试显示下一条消息-->
<!--      this.isVisible = false;-->
<!--      this.currentMessage = '';-->
<!--    },-->
<!--    showNotification(message, glowing) {-->
<!--      const msg = {-->
<!--        message: message,-->
<!--        glowing: glowing-->
<!--      };-->
<!--      this.messageQueue.push(msg);-->
<!--      //this.isGlowing = glowing; // 设置发光效果-->
<!--      if (!this.isVisible) {-->
<!--        this.showNextMessage();-->
<!--      }-->
<!--    },-->
<!--    handleVisibilityChange() {-->
<!--      if (document.visibilityState === 'visible') {-->
<!--        // 页面变为可见，恢复消息滚动-->
<!--        this.showNextMessage();-->
<!--      } else {-->
<!--        // 页面变为不可见，暂停当前消息的滚动-->
<!--        this.pauseMessageScrolling();-->
<!--      }-->
<!--    },-->
<!--    pauseMessageScrolling() {-->
<!--      // 实现消息滚动的暂停逻辑-->
<!--      // 注意：这里需要根据你的具体实现来编写代码-->
<!--      // 例如，你可能需要停止当前动画并记录当前消息的状态-->
<!--      this.isVisible = false;-->
<!--    },-->
<!--    // 注意：根据你的实现，可能需要修改 showNextMessage 方法，-->
<!--    // 以确保在页面不可见时不立即显示消息-->
<!--    showNextMessage() {-->
<!--      if (document.visibilityState === 'visible' && this.messageQueue.length > 0 && !this.isVisible) {-->
<!--        // 只有在页面可见时才显示下一条消息-->
<!--        const msg = this.messageQueue.shift();-->
<!--        this.currentMessage = msg.message;-->
<!--        this.isGlowing = msg.glowing;-->
<!--        this.isVisible = true;-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--};-->
<!--</script>-->

<!--<style scoped>-->
<!--@keyframes scrollText {-->
<!--  from {-->
<!--    transform: translateX(100vw); /* 从屏幕右边外开始 */-->
<!--  }-->
<!--  to {-->
<!--    transform: translateX(-100%); /* 移动到完全不在屏幕内 */-->
<!--  }-->
<!--}-->
<!--.golden-glow {-->
<!--  font-weight: bold;-->
<!--  font-size: 18px; /* 调整大小以适应你的设计 */-->
<!--  color: #FFD700;-->
<!--  text-shadow:-->
<!--      0 0 3px #FFD700,-->
<!--      0 0 5px #FFA500,-->
<!--      0 0 7px #FF4500;-->

<!--}-->

<!--.notification {-->
<!--  position: fixed;-->
<!--  width: 100%;-->
<!--  top: 0;-->
<!--  background-color: #ffffff;-->
<!--  color: teal;-->
<!--  z-index: 99999;-->
<!--  border-radius: 10px 10px 10px 10px;-->
<!--  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);-->
<!--  padding: 10px 10px 10px 10px;-->
<!--}-->
<!--.scrolling-text {-->
<!--  display: inline-block;-->
<!--  animation: scrollText 20s linear forwards; /* 移除了 infinite，让动画只播放一次 */-->
<!--}-->
<!--.fade-enter-active, .fade-leave-active {-->
<!--  transition: opacity 0.5s;-->
<!--}-->
<!--.fade-enter, .fade-leave-to /* .fade-leave-active for <2.1.8 */ {-->
<!--  opacity: 0;-->
<!--}-->
<!--</style>-->
<template>
  <transition name="fade" @after-leave="showNextMessage">
    <div v-if="isVisible" class="notification">
      <div :class="['scrolling-text', { 'golden-glow': isGlowing }]" @animationend="handleAnimationEnd">
        {{ currentMessage }}
      </div>
      <span class="close-btn" @click="closeNotification">×</span>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      messageQueue: [],
      currentMessage: '',
      isGlowing: false,
    };
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  watch: {
    messageQueue() {
      if (!this.isVisible && this.messageQueue.length > 0) {
        this.showNextMessage();
      }
    }
  },
  methods: {
    handleAnimationEnd() {
      this.isVisible = false;
      this.currentMessage = '';
    },
    showNotification(message, glowing) {
      this.messageQueue.push({
        message: message,
        glowing: glowing
      });
      if (!this.isVisible) {
        this.showNextMessage();
      }
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.showNextMessage();
      } else {
        this.pauseMessageScrolling();
      }
    },
    pauseMessageScrolling() {
      this.isVisible = false;
    },
    showNextMessage() {
      if (document.visibilityState === 'visible' &&
        this.messageQueue.length > 0 &&
        !this.isVisible) {
        const msg = this.messageQueue.shift();
        this.currentMessage = msg.message;
        this.isGlowing = msg.glowing;
        this.isVisible = true;
      }
    },
    closeNotification() {
      this.isVisible = false;
      this.currentMessage = '';
      this.$nextTick(() => {
        if (this.messageQueue.length > 0) {
          this.showNextMessage();
        }
      });
    }
  }
};
</script>

<style scoped>
@keyframes scrollText {
  from { transform: translateX(100vw); }
  to { transform: translateX(-100%); }
}

.notification {
  position: fixed;
  width: 100%;
  top: 0;
  background-color: #ffffff;
  color: teal;
  z-index: 99999;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 10px 40px 10px 20px;
  overflow: hidden;
}

.scrolling-text {
  display: inline-block;
  animation: scrollText 20s linear forwards;
  max-width: calc(100% - 40px);
}

.golden-glow {
  font-weight: bold;
  font-size: 18px;
  color: #FFD700;
  text-shadow: 0 0 3px #FFD700,
  0 0 5px #FFA500,
  0 0 7px #FF4500;
}

.close-btn {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 24px;
  color: #aaa;
  padding: 0 8px;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #ff4444;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
